export default "__VITE_ASSET__ef631881__"